import { Injectable } from '@angular/core';

import { aggregator } from '@env/aggregator/aggregator';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';

@Injectable({
  providedIn: 'root'
})
export class AggregatorFeatureFlagService {
  isEnabled(featureFlag: AggregatorFeatureFlag): boolean {
    return !!aggregator.features[featureFlag];
  }
}
